import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-circle',
  templateUrl: './spinner-circle.component.html',
  styleUrls: ['./spinner-circle.component.scss']
})
export class SpinnerCircleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
